import * as yup from 'yup';

export default yup.object().shape({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  mobile: yup.string().matches(/^[0-9]{8,13}$/, 'Mobile number must be just numbers and minimum 8 digits and maximum 13 digits long'),
  old_password: yup.string(),
  password: yup.string().when('old_password', (old_password, new_password) =>
    old_password ? new_password.min(8, "The password must be at least 8 characters.").required('New password is required') : new_password
  ),
  password_confirmation: yup.string().when('old_password', (old_password, password_confirmation) =>
    (old_password && yup.ref('password')) ? password_confirmation.oneOf([yup.ref('password'), null], "The password confirmation doesn't match the password") : password_confirmation
  ),
});
